import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Notation from "../components/Notation";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}

        {/* Breadcrumb */}
        <Breadcrumb title="Notation" />

        {/* UsersListLayer */}
        <Notation />


    </>
  );
};

export default UsersListPage; 